/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import axios from 'axios';

import HeaderTitle from "../../components/includes/HeaderTitle";
import StaffCallNetworkResult from "../../components/members/StaffCallNetworkResult";
import {LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//직원 관리
const StaffCallNetworkList = ({setMenuType,setMenuItem}) => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  //회원목록
  const [varStaffCallNetwork,setStaffCallNetwork] = useState([]);

  //회원목록 읽어오기
  const getStaffCallingNetworkList = async () => {
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staff_calling_network`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setStaffCallNetwork(datas.results);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffCallingNetworkList');
    getStaffCallingNetworkList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle="직원 연락망 현황" />
      <div className="admin-content">
        <StaffCallNetworkResult varStaffCallNetwork={varStaffCallNetwork} setStaffCallNetwork={setStaffCallNetwork}
                                getStaffCallingNetworkList={getStaffCallingNetworkList}/>
      </div>
    </div>
  );
}
export default StaffCallNetworkList;